module.exports = __webpack_public_path__ + "static/media/paneaux_vitres.565e1f3b.webp";